import { Separator } from "@/components/ui/separator";
import { useNavigate, Link } from "react-router-dom";
import legitScriptBadge from "@/assets/legitscript-certified.png";

const TrueWellnessFooter = () => {
  const navigate = useNavigate();

  const links = {
    treatments: [
      { label: "Medical Weight Loss", href: "#weight" },
    ],
    learnMore: [
      { label: "Blog", href: "/wellness/blog", isRoute: true },
      { label: "TeleHealth", href: "#support" },
      { label: "Book Consultation", href: "https://calendly.com/nick-ogle-nudalabs", isExternal: true },
    ],
    legal: [
      { label: "Privacy Policy", href: "/privacy", isRoute: true },
      { label: "Terms of Service", href: "/terms", isRoute: true },
    ],
  };


  const handleLinkClick = (link: { href: string; isRoute?: boolean; isExternal?: boolean }) => {
    if (link.isRoute) {
      navigate(link.href);
    } else if (link.isExternal) {
      window.open(link.href, "_blank");
    } else if (link.href.startsWith("#") && link.href.length > 1) {
      const element = document.getElementById(link.href.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="bg-[#181818] text-white py-16 md:py-20 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1 space-y-4">
              <Link to="/" className="inline-block hover:opacity-80 transition-opacity">
                <span className="text-xl md:text-2xl font-black tracking-tight text-white drop-shadow-md">
                  Hillary<span className="text-[#ffdb4d]">Rx</span>
                </span>
              </Link>
              <p className="text-sm text-white/60 leading-relaxed">
                Provider-guided wellness programs for your whole self.
              </p>
            </div>

            {/* Treatments */}
            <div className="space-y-4">
              <h4 className="font-bold text-sm uppercase tracking-wider text-[#ffdb4d]">
                Treatments
              </h4>
              <ul className="space-y-3">
                {links.treatments.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => handleLinkClick(link)}
                      className="text-sm text-white/60 hover:text-[#ffdb4d] transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Learn More */}
            <div className="space-y-4">
              <h4 className="font-bold text-sm uppercase tracking-wider text-[#ffdb4d]">
                Learn More
              </h4>
              <ul className="space-y-3">
                {links.learnMore.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => handleLinkClick(link)}
                      className="text-sm text-white/60 hover:text-[#ffdb4d] transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal */}
            <div className="space-y-4">
              <h4 className="font-bold text-sm uppercase tracking-wider text-[#ffdb4d]">
                Legal
              </h4>
              <ul className="space-y-3">
                {links.legal.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => handleLinkClick(link)}
                      className="text-sm text-white/60 hover:text-[#ffdb4d] transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <Separator className="bg-white/10 mb-8" />

          {/* Medical Disclosure */}
          <div className="mb-6">
            <h5 className="text-xs font-semibold text-white/60 mb-2">Medical & Regulatory Disclosure</h5>
            <p className="text-xs text-white/40 max-w-4xl mx-auto leading-relaxed">
              Services are provided via telehealth and may include provider-prescribed compounded peptides. Compounded medications are not FDA-approved and may be prescribed for off-label or investigational use based on a provider's independent medical judgment. Results vary and risks exist. Services are self-pay and not insurance-covered. Not for emergency or primary care.
            </p>
          </div>

          <Separator className="bg-white/10 mb-6" />

          {/* Disclaimer & Copyright */}
          <div className="space-y-6 text-center">
            <p className="text-xs text-white/40 max-w-2xl mx-auto leading-relaxed">
              All treatments require medical evaluation and approval through licensed providers. 
              HillaryRx does not provide medical advice, diagnosis, or treatment. 
              Consult with a healthcare provider for personalized medical guidance.
            </p>
            
            {/* LegitScript Badge */}
            <div className="flex justify-center">
              <img 
                src={legitScriptBadge} 
                alt="LegitScript Certified" 
                className="h-16 md:h-20 opacity-90 hover:opacity-100 transition-opacity"
              />
            </div>
            
            <p className="text-sm text-white/60">
              © {new Date().getFullYear()} HillaryRx. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default TrueWellnessFooter;
